var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b44ef7658c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 67.179688 4 L 342.429688 4 L 342.429688 371.40625 L 67.179688 371.40625 Z M 67.179688 4 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b44ef7658c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 91.789062 371.164062 C 99.800781 371.164062 108.957031 367.722656 118.398438 361.132812 L 322.117188 221.609375 C 335.277344 212.726562 342.429688 200.40625 342.429688 187.511719 C 342.429688 174.621094 335.277344 162.300781 322.117188 153.417969 L 118.683594 13.890625 C 109.242188 7.304688 99.800781 4.152344 91.789062 4.152344 C 76.625 4.152344 67.179688 16.472656 67.179688 36.8125 L 67.179688 338.5 C 67.179688 358.84375 76.625 371.164062 91.789062 371.164062 Z M 91.789062 371.164062 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.777774d363f0ddcb43e264b7a8e1274e.svg";
export { ForwardRef as ReactComponent };